<template>
  <v-form @submit.prevent ref="form" v-model="valid">
      <input-form v-model="doc" />
      <v-btn color="amber" light class="mt-5" @click="onSubmit">SAVE</v-btn>
  </v-form>
</template>

<script>
// @ is an alias to /src
import InputForm from "./TravelForm"
import { mapState } from "vuex";
const fb = require("@/firebaseConfig.js");

export default {
  name: "UserTravelAdd",
  components: {
    InputForm
  },
  data () {
    return {
      valid: true,
      doc: {
        title: "",
        flag: "",
        strapline: "",
        description: "",
        promise: "",
        justification: [],
        pillars: []
      },
    }
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel"
    ])
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault()
      this.validate();
      if (this.valid) {
         let ref = fb.travelExCollection.doc();
        ref.set({
          createdOn: new Date(),
          id: ref.id,
          doc: this.populateField(this.doc),
          uid: this.currentUser.uid,
          pid: this.currentProjectModel.id,
        }).then(() => {
          this.$emit('complete')
        })
        .catch((error) => {
          alert("Error adding document: ", error);
        });
      }
    },
    populateField(field) {
      return field ? field : null
    },
    validate () {
      this.$refs.form.validate()
    },
  }
};
</script>
